import { executeCapability } from '../utils/capabilityExecute'
import type { ContactEntry } from './profileService'

export async function listDirectoryContacts(q?: string): Promise<ContactEntry[]> {
  return executeCapability<ContactEntry[]>({
    app: 'pr',
    capability: 'pr.contactsList',
    input: q ? { q } : {},
  })
}

export type SignatureRecipientUnselectableReason =
  | 'contact_only'
  | 'no_email'
  | 'workspace_suspended'
  | 'contact_duplicate_email'

export type SignatureRecipientRow = {
  rowKey: string
  email: string
  displayName: string
  employeeId: string | null
  sources: ('contact' | 'workspace')[]
  /** True when this row links a Portal contact to the same Workspace primary email. */
  matchedToPortal: boolean
  selectable: boolean
  unselectableReason?: SignatureRecipientUnselectableReason
  contact: ContactEntry | null
}

export type WorkspaceDirectoryMergeResult = {
  workspaceConfigured: boolean
  workspaceError: string | null
  workspaceUserCount: number
  rowCount: number
  selectableCount: number
  rows: SignatureRecipientRow[]
}

export async function fetchWorkspaceDirectoryMerge(q?: string): Promise<WorkspaceDirectoryMergeResult> {
  return executeCapability<WorkspaceDirectoryMergeResult>({
    app: 'pr',
    capability: 'pr.workspaceDirectoryMerge',
    input: q ? { q } : {},
  })
}

export type SignatureApplyRowResult = {
  rowKey: string
  email: string
  ok: boolean
  error?: string
}

export type SignatureApplyResult = {
  results: SignatureApplyRowResult[]
  summary: {
    ok: number
    failed: number
  }
}

export async function applyEmailSignatures(input: {
  templateHtml: string
  rowKeys: string[]
}): Promise<SignatureApplyResult> {
  return executeCapability<SignatureApplyResult>({
    app: 'pr',
    capability: 'pr.signatureApply',
    input,
  })
}
